export { default } from './InlineEdit';
export type { InlineEditProps } from './InlineEdit';
